export default __webpack_public_path__ + "static/media/up.76e41756.png";